export default __webpack_public_path__ + "static/media/Montserrat-Italic.e7728c27.ttf";